module.exports = __webpack_public_path__ + "img/default-image.383262ab.svg";